export default function Cta() {
  return (
    <section className="bg-background-100 py-16 md:py-20">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="relative overflow-hidden rounded-xl bg-primary-600 px-6 py-12 md:px-12 md:py-14">
          <div className="pointer-events-none absolute -right-8 -top-10 h-56 w-56 rounded-full bg-primary-500/50 blur-2xl"></div>
          <div className="pointer-events-none absolute -bottom-12 -left-6 h-48 w-48 rounded-full bg-accent-500/40 blur-2xl"></div>
          <div className="relative grid grid-cols-1 items-center gap-8 lg:grid-cols-2">
            <div>
              <h2 className="font-display text-2xl font-black leading-snug text-background-50 md:text-3xl">
                有些事，不说出来就永远不会被解决
              </h2>
              <p className="mt-3 max-w-lg text-[15px] leading-7 text-primary-100">
                你掌握的每一条线索，都可能让一个人、一个行业、一个社区变得更好一点点。今天，就从匿名说出你知道的开始。
              </p>
            </div>
            <div className="flex flex-col items-start gap-3 sm:flex-row lg:justify-end">
              <a
                href="#form"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-background-50 px-6 py-3 text-sm font-bold text-primary-700 transition-colors hover:bg-background-100"
              >
                <i className="ri-send-plane-fill text-base" aria-hidden="true"></i>
                现在匿名投稿
              </a>
              <a
                href="#reports"
                className="inline-flex items-center justify-center whitespace-nowrap rounded-md border border-primary-300/70 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-500/40"
              >
                先看看已有报道
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}